module.exports = __webpack_public_path__ + "static/media/share-illustration.019099cc.svg";